import { codeStates } from './constants'

const stripCode = code => code?.replace(/[\s.-]/g, '') || ''

const isValidHsCode = code => /^\d{6,}$/.test(stripCode(code))

const isValidHtsCode = code => /^\d{10}$/.test(stripCode(code))

export const getHsCodeState = (currentCode, proposedCode, isValid) => {
  if (!currentCode) return codeStates.missing
  if (isValid === false || (isValid == null && !isValidHsCode(currentCode))) return codeStates.invalid
  if (currentCode === proposedCode) return codeStates.match
  return codeStates.mismatch
}

export const getHtsCodeState = (currentCode, proposedCode, isValid) => {
  if (!currentCode) return codeStates.missing
  if (isValid === false || (isValid == null && !isValidHtsCode(currentCode))) return codeStates.invalid
  if (currentCode === proposedCode) return codeStates.match
  return codeStates.mismatch
}

export const isCodeActionable = codeState => codeState !== codeStates.match

export const itemHasHtsCode = item => Boolean(item?.hts_code || item?.proposed_hts_code)
